import React from 'react';
import { Cell, Pie, PieChart, Tooltip } from 'recharts';

const COLORS = [
  '#b39ddb', // Soltero(a)
  '#9575cd', // Casado(a)
  '#7986cb', // Viudo(a)
  '#4fc3f7', // Conviviente Civil
  '#80cbc4' // Divorciado(a)
];

const CivilStateGraph = ({ title = {} }) => {
  const data = [
    { name: 'Soltero(a)', value: title.single },
    { name: 'Casado(a)', value: title.married },
    { name: 'Viudo(a)', value: title.widower },
    { name: 'Conviviente Civil', value: title.civilUnionAgreement },
    { name: 'Divorciado(a)', value: title.divorced }
  ];

  return (
    <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
      <PieChart width={70} height={70}>
        <Pie
          data={data}
          cx="50%"
          cy="50%"
          innerRadius={22}
          outerRadius={32}
          dataKey="value"
          startAngle={90}
          endAngle={-270}
          paddingAngle={2}
        >
          {data.map((entry, index) => (
            <Cell key={`cell-${entry.name}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
        <Tooltip />
      </PieChart>
      <div style={{ marginLeft: 30 }}>
        {data.map((entry, index) => (
          <div
            key={entry.name}
            style={{
              display: 'flex',
              alignItems: 'center',
              marginBottom: 2
            }}
          >
            <span
              style={{
                display: 'inline-block',
                width: 9,
                height: 9,
                backgroundColor: COLORS[index % COLORS.length],
                borderRadius: '50%',
                marginRight: 6
              }}
            />
            <span style={{ color: '#757575', fontSize: 10 }}>{entry.name}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
export default CivilStateGraph;
